import './VumaContactInformation.css';
import React, { Component } from 'react';

import Back from '../Common/Back/Back';
import Input from '../Common/Input/Input';

import {
	checkInputValidity
} from "./../../Utility/utility";
import { SalesContext } from '../../Context/SalesContext';
import { submitVumareachOrder } from '../../Services/Services';
import { tagOnVumatelContactPageLoad, tagOnVumatelErrorPopup } from './../../Tagging/VumareachTagging';

import IdPassport from "./../IdPassport/IdPassort";
import PrivacyStatment from "./../PrivacyStatment/PrivacyStatment";

class VumaContactInformation extends Component {
	static contextType = SalesContext;
  miniAppProactiveSales = !!(window.isFtthMA);

	state = {
		formComponents: {
			firstName: {
				name: "*First name",
				type: "input",
				value: this.context.vumaContactDetails.firstName,
				validations: {
					required: true,
					invalidMessage: "Please enter a valid first name",
					maxLength: 50,
					minLength: 1
				},
				config: {
					type: "text",
					required: true
				},
				isValid: false,
				isTouched: false
			},
			lastName: {
				name: "*Last name",
				type: "input",
				value: this.context.vumaContactDetails.lastName,
				validations: {
					required: true,
					invalidMessage: "Please enter a valid last name",
					maxLength: 50,
					minLength: 1
				},
				config: {
					required: true
				},
				isValid: false,
				isTouched: false
			},
			email: {
				name: "*Email address",
				type: "input",
				value: this.context.vumaContactDetails.email,
				validations: {
					required: true,
					invalidMessage: "Please enter a valid email address",
					type: "email"
				},
				config: {
					type: "text",
					required: true
				},
				isValid: false,
				isTouched: false
			},
			contactNumber: {
				name: "*Contact number",
				type: "input",
				value: this.context.vumaContactDetails.cellPhone,
				validations: {
					required: true,
					isPhoneNumber: true,
					invalidMessage: "Please enter a valid cellphone number",
					minLength: 10,
					type: 'cellphoneNo'
				},
				config: {
					type: "text",
					required: true,
					maxLength: 12
				},
				isValid: false,
				isTouched: false
			}
		},
		isFormValid: false,
		isIdPassportValid: false,
		formSubmitAttempt: 0,
		hasError: false
	}

	formComponentChangeHandler = (event, inputIdentifier) => {
		const formCompsCopy = { ...this.state.formComponents };
		const isPassportIdValid = this.state.isIdPassportValid;
		const changedComponent = { ...formCompsCopy[inputIdentifier] };
		changedComponent.value = event.target.value;
		changedComponent.isValid = checkInputValidity(changedComponent.value, changedComponent.validations);
		changedComponent.isTouched = true;

		this.context.setUserDetails({ key: inputIdentifier, value: changedComponent.value });

		const newFormComps = { ...formCompsCopy, [inputIdentifier]: changedComponent }
		this.setState({ formComponents: newFormComps, isFormValid: this.checkFormValidity(newFormComps, isPassportIdValid) });

		this.context.setVumaContactDetails({
			firstName: newFormComps.firstName.value,
			lastName: newFormComps.lastName.value,
			email: newFormComps.email.value,
			cellPhone: newFormComps.contactNumber.value
		})
	}

	checkFormValidity = (form, idPassportValid) => form.contactNumber.isValid && form.email.isValid && form.firstName.isValid && form.lastName.isValid && idPassportValid;

	submitLeadRequest = () => {
		this.context.setShowSpinner(true);
		submitVumareachOrder(this.context).then(res => {
			this.context.setUserDetails({ key: 'referenceNo', value: res.result.quoteNumber });
			this.props.history.push('/cloud/fibre/sales/success-vuma');
			this.context.setShowSpinner(false);
		}).catch(error => {
			console.error(error);
			this.context.setShowSpinner(false);
			this.setState({ hasError: true });
		})
	}

	resetError = () => {
		this.setState({
			hasError: false
		});
	}

	errorResubmitClickHandler = () => {
		this.setState(prevState => {
			return {
				hasError: false,
				formSubmitAttempt: prevState.formSubmitAttempt + 1
			}
		});
	}

	componentDidMount() {
		tagOnVumatelContactPageLoad();

		if (this.context.selectedPackage === null) {
			this.props.history.push('/cloud/fibre/sales/choosePlan');
			return;
		}

		const prevData = this.context.userDetails;
		const formCompsCopy = { ...this.state.formComponents };
		for (let key in prevData) {
			if (prevData[key] === "")
				continue;

			const changedComponent = { ...formCompsCopy[key] };
			changedComponent.value = prevData[key];

			changedComponent.isValid = checkInputValidity(
				changedComponent.value,
				changedComponent.validations
			);

			changedComponent.isTouched = true;

			formCompsCopy[key] = changedComponent;
		}

		let isIdValid = false;
		if (this.context.employmentDetails.selectedIdTab === "passportNumber") {
			isIdValid = this.context.employmentDetails.passportNumber !== "";
		} else {
			isIdValid = this.context.employmentDetails.idNumber !== "";
		}

		const isFormValid = this.checkFormValidity(formCompsCopy, isIdValid);
		this.setState({ formComponents: formCompsCopy, isFormValid: isFormValid });

	}

	idPassportChangeHandler = isValid => {
		this.setState({ ...this.state, isIdPassportValid: isValid, isFormValid: this.checkFormValidity(this.state.formComponents, isValid) });
	}

	render() {
		if (this.state.hasError) {
			const errorMsg = 'We are unable to get address information due to technical error. Please try again.';
			this.context.setErrorObject({ message: errorMsg });
			tagOnVumatelErrorPopup(errorMsg);
			this.props.history.push('/cloud/fibre/sales/error');
			return null;
		}
		return (
			<React.Fragment>
				<hr className="vuma-contactInfo-hr" />
				<div automationid="SalesLead_Div_ContactInformationHeading_11">
					<div className="vuma-contactInfo-wrapper" automationid="SalesLead_Div_ContactInformationHeading_12">
						<div className="vuma-contactInfo-title" automationid={`SalesLead_Div_ContactInformationHeading_0`}>
							Please enter your details below to complete your order.
						</div>
						<p automationid="SalesLead_Div_ContactInformationHeading_13">Please enter your personal details below.</p>
						<div className="vuma-contactInfo-form-input-row" automationid="SalesLead_Div_ContactInformationHeading_14">
							<Input
								inputIdentifier="firstName"
								changed={this.formComponentChangeHandler}
								{...this.state.formComponents.firstName}
								automationidattr={`FirstNameVuma`}
							/>
							<Input
								inputIdentifier="lastName"
								changed={this.formComponentChangeHandler}
								{...this.state.formComponents.lastName}
								automationidattr={`LastNameVuma`}
							/>
						</div>
						<div className="vuma-contactInfo-form-input-row" automationid="`SalesLead_Div_ContactInformationHeading_15">
							<div className="input-container" automationid="SalesLead_Div_ContactInformationHeading_16">
								<Input
									inputIdentifier="email"
									changed={this.formComponentChangeHandler}
									{...this.state.formComponents.email}
									automationidattr={`EmailVuma`}
									style={{ padding: 0 }}
								/>
								<span className="vuma-contactInfo-sub-input-title" automationid="SalesLead_Div_ContactInformationHeading_16">You will receive payment instructions</span>
							</div>
							<Input
								inputIdentifier="contactNumber"
								changed={this.formComponentChangeHandler}
								{...this.state.formComponents.contactNumber}
								automationidattr={`ContactNumberVuma`}
							/>
						</div>
						<IdPassport validIdPassportDetails={this.idPassportChangeHandler} />
						<button
							onClick={this.submitLeadRequest}
							style={{ marginTop: "2rem" }}
							automationid="SalesLead_Button_ContactInformationHeading_11"
							disabled={!this.state.isFormValid}
							className="vuma-submit-order-red-button"
						>
							SUBMIT ORDER
						</button>
					</div>

				</div>
				{!this.miniAppProactiveSales && <PrivacyStatment type="vuma" /> }
				<div automationid="SalesLead_Div_ContactInformationHeading_16">
					<Back
						// buttonName="SUBMIT DETAILS"
						nextUrl="/success"
						// onNextClick={this.submitLeadRequest}
						// enabledButton={this.state.isFormValid}
						automationidattr={`ContactInformationVuma`}
					/>
				</div>
			</React.Fragment>
		);
	}
}

export default VumaContactInformation;